import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
const useStyles = createUseStyles({
  divInfosCollab: {
    display: "flex",
    flexDirection: "column",
    padding: "15px 0px 15px 0px",
    gap: "20px",
  },
  divInfosCollabDashboard: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },

  divDate: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "15px",
  },
  divImat: {
    display: "flex",
    flexDirection: "row",
    minHeight: "40px",
    padding: "10px",
    justifyContent: "space-between",
    backgroundColor: colors.default,
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    // Registration / brand / model / fuel are real values now, not the fixed
    // four short placeholders this row was built for, so they need room to
    // wrap instead of a locked 40px height.
    flexWrap: "wrap",
    "& > div": { flex: "1 1 auto", minWidth: 0 },
    "@media (max-width:599.95px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "4px",
    },
  },
});

export default useStyles;
